import React from 'react';

const FAQItem = ({ question, answer }) => (
  <div className="py-6">
    <details className="group">
      <summary className="flex justify-between items-center font-medium cursor-pointer list-none">
        <span className="text-lg font-semibold text-gray-900">{question}</span>
        <span className="transition group-open:rotate-180">
          <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24">
            <path d="M6 9l6 6 6-6"></path>
          </svg>
        </span>
      </summary>
      <p className="text-gray-600 mt-3 group-open:animate-fadeIn">
        {answer}
      </p>
    </details>
  </div>
);

const AboutFAQ = () => {
  const faqItems = [
    {
      question: "Topluluğa nasıl üye olabilirim?",
      answer: "Topluluğumuza üye olmak için web sitemizdeki \"Üye Ol\" bölümünden kayıt formunu doldurabilirsiniz. Üyelik için herhangi bir özel bir yetenek gerekmemektedir. Tüm İYTE öğrencileri topluluğumuza katılabilir."
    },
    {
      question: "Müzik odasını kullanmak için ne yapmam gerekiyor?",
      answer: "Müzik odasını kullanmak için çevrimiçi rezervasyon sistemimiz üzerinden uygun bir zaman dilimi seçerek rezervasyon yapmanız yeterlidir. Rezervasyon yaptıktan sonra size özel bir kod gönderilecek ve bu kodu kullanarak odaya erişim sağlayabileceksiniz."
    },
    {
      question: "Daha önce hiç enstrüman çalmadım, etkinliklerinize katılabilir miyim?",
      answer: "Elbette! Topluluğumuz her seviyeden müzik ilgilisine açıktır. Düzenlediğimiz başlangıç düzeyi atölyeler ve eğitim etkinlikleri ile müziğe ilk adımınızı atmanıza yardımcı olabiliriz. Ayrıca, dinleyici olarak tüm etkinliklerimize katılabilirsiniz."
    },
    {
      question: "Konser ve etkinliklerde nasıl yer alabilirim?",
      answer: "Konser ve etkinliklerde performans sergilemek için topluluk yöneticileriyle iletişime geçebilir veya etkinlik duyurularında belirtilen başvuru formlarını doldurabilirsiniz. Düzenli olarak gerçekleştirdiğimiz jam session'lara katılmak da iyi bir başlangıç olabilir."
    },
    {
      question: "Müzik odası rezervasyon sistemi nasıl çalışıyor?",
      answer: "Web sitemiz üzerinden oda rezervasyon sistemimize giriş yaparak, boş olan zaman dilimlerini görebilir ve uygun bir slot seçebilirsiniz. Rezervasyon yaptıktan sonra, size özel bir pin kodu gönderilecektir. Rezervasyon saatinizde bu kodu kullanarak odaya erişim sağlayabilirsiniz."
    }
  ];

  return (
    <div className="p-6 sm:p-10">
      <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">
        Sıkça Sorulan Sorular
      </h2>
      <div className="max-w-3xl mx-auto divide-y divide-gray-200">
        {faqItems.map((item, index) => (
          <FAQItem key={index} question={item.question} answer={item.answer} />
        ))}
      </div>
    </div>
  );
};

export default AboutFAQ;